import { useI18n } from '../context/I18nContext';
import { Link } from 'react-router-dom';
import { SocialShare } from './SocialShare';

const LOGO_ICON = "https://customer-assets.emergentagent.com/job_no-sub-pdf/artifacts/8avttwow_logohexoworkssanstitre.png";

const legalLinks = [
  { slug: 'legal-notice', en: 'Legal Notice', fr: 'Mentions légales' },
  { slug: 'terms-of-sale', en: 'Terms of Sale', fr: 'CGV' },
  { slug: 'privacy-policy', en: 'Privacy Policy', fr: 'Confidentialité' },
  { slug: 'cookie-policy', en: 'Cookie Policy', fr: 'Cookies' },
  { slug: 'eula', en: 'EULA', fr: 'EULA' },
];

const moreLegalLinks = [
  { slug: 'security-policy', en: 'Security', fr: 'Sécurité' },
  { slug: 'data-processing-agreement', en: 'DPA', fr: 'DPA / RGPD' },
  { slug: 'acceptable-use-policy', en: 'Acceptable Use', fr: 'Utilisation acceptable' },
  { slug: 'trademark-policy', en: 'Trademark', fr: 'Marque' },
  { slug: 'open-source', en: 'Open Source', fr: 'Open Source' },
];

export const Footer = () => {
  const { t, lang } = useI18n();
  const l = lang === 'fr' ? 'fr' : 'en';

  return (
    <footer className="bg-background border-t border-border py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-5 gap-12 mb-12">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 mb-4">
              <img src={LOGO_ICON} alt="HexoPDF" className="w-7 h-7" />
              <span className="font-heading font-bold text-lg text-foreground">
                Hexo<span className="text-blue-500">PDF</span>
              </span>
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed">
              {t('footer.tagline')}
            </p>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-[0.15em] text-muted-foreground font-medium mb-4" data-testid="footer-section-product">{t('footer.sections.product')}</h4>
            <ul className="space-y-2.5">
              <li>
                <button
                  onClick={() => document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-muted-foreground hover:text-foreground text-sm transition-colors"
                >
                  {t('nav.features')}
                </button>
              </li>
              <li>
                <Link to="/pricing" className="text-muted-foreground hover:text-foreground text-sm transition-colors" data-testid="footer-pricing-link">
                  {t('nav.pricing')}
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-muted-foreground hover:text-foreground text-sm transition-colors" data-testid="footer-faq-link">
                  {t('nav.faq')}
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-muted-foreground hover:text-foreground text-sm transition-colors" data-testid="footer-blog-link">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/resources" className="text-muted-foreground hover:text-foreground text-sm transition-colors" data-testid="footer-resources-link">
                  {t('nav.resources')}
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-[0.15em] text-muted-foreground font-medium mb-4" data-testid="footer-section-compare">{t('footer.sections.compare')}</h4>
            <ul className="space-y-2.5">
              <li><Link to="/compare/adobe" className="text-muted-foreground hover:text-foreground text-sm transition-colors" data-testid="footer-compare-adobe">{t('footer.compare.adobe')}</Link></li>
              <li><Link to="/compare/foxit" className="text-muted-foreground hover:text-foreground text-sm transition-colors" data-testid="footer-compare-foxit">{t('footer.compare.foxit')}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-[0.15em] text-muted-foreground font-medium mb-4" data-testid="footer-section-legal">{t('footer.sections.legal')}</h4>
            <ul className="space-y-2.5">
              {legalLinks.map((link) => (
                <li key={link.slug}>
                  <Link to={`/legal/${link.slug}`} className="text-muted-foreground hover:text-foreground text-sm transition-colors" data-testid={`footer-legal-${link.slug}`}>
                    {link[l]}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-[0.15em] text-muted-foreground font-medium mb-4" data-testid="footer-section-more-legal">
              {l === 'fr' ? 'Autres' : 'More'}
            </h4>
            <ul className="space-y-2.5">
              {moreLegalLinks.map((link) => (
                <li key={link.slug}>
                  <Link to={`/legal/${link.slug}`} className="text-muted-foreground hover:text-foreground text-sm transition-colors" data-testid={`footer-legal-${link.slug}`}>
                    {link[l]}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-muted-foreground/60 text-xs">{t('footer.copyright')}</p>
          <SocialShare />
          <div className="flex items-center gap-2">
            <span className="text-muted-foreground/60 text-xs">{t('footer.made_by')}</span>
            <span className="text-muted-foreground text-xs font-medium">{t('footer.brand')}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
